import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { GroupsService } from '../../services/groups.service';
import { SidenavService } from '../../services/sidenav.service';
import { SnackbarService } from '../../services/snackbar.service';
import { UsersService } from '../../services/users.service';
import { PromptModalComponent } from '../prompt-modal/prompt-modal.component';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss'],
  standalone: false,
})
export class GroupsComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  sidenav: MatSidenav;
  groups: any[];
  usersByGroup: any = { NOGROUP: [] };

  private users: any[];

  searchQuery: string = '';
  activeFilter: string | null = null; // groupId, 'NOGROUP', or null (= all)

  get allUsers(): any[] {
    return this.users ?? [];
  }

  get filteredUsers(): any[] {
    let list = this.allUsers;
    if (this.activeFilter === 'NOGROUP') {
      list = list.filter((u) => !u.groups || u.groups.length === 0);
    } else if (this.activeFilter) {
      list = list.filter((u) => u.groups?.includes(this.activeFilter));
    }
    const q = this.searchQuery.trim().toLowerCase();
    if (q) {
      list = list.filter((u) => u.name?.toLowerCase().includes(q));
    }
    return list;
  }

  setFilter(value: string | null) {
    this.activeFilter = this.activeFilter === value ? null : value;
  }

  constructor(
    private sidenavService: SidenavService,
    private groupsService: GroupsService,
    private usersService: UsersService,
    private dialog: MatDialog,
    private snackbar: SnackbarService,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
  }

  async ngOnInit() {
    this.groups = await this.groupsService.getList();
    this.users = await this.usersService.getList();
    this.processUsers();
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/admin']);
  }

  createGroup() {
    this.dialog
      .open(PromptModalComponent, {
        panelClass: 'prompt-dialog',
        data: {
          title: 'Crear Grupo',
          label: 'Nombre del grupo',
        },
      })
      .afterClosed()
      .subscribe((value) => {
        if (!value) {
          return;
        }

        this.blockUI.start();
        this.groupsService
          .create({ name: value })
          .then((newGroup: any) => {
            this.groups.unshift(newGroup);
            this.blockUI.stop();
            this.snackbar.success('El grupo se ha creado correctamente.');
          })
          .catch((error) => {
            this.blockUI.stop();
            this.snackbar.error(error.message);
          });
      });
  }

  changeGroup(user: any, groupId?: string) {
    if (!user.groups) {
      user.groups = [];
    }

    if (!groupId) {
      user.groups = [];
    } else {
      user.groups.push(groupId);
    }

    this.blockUI.start();
    this.usersService
      .update(user)
      .then(() => {
        this.blockUI.stop();
        this.processUsers();
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackbar.error(error.message);
      });
  }

  isInGroup(user: any, groupId: string): boolean {
    return user.groups?.includes(groupId) ?? false;
  }

  toggleGroup(user: any, groupId: string) {
    if (!user.groups) user.groups = [];
    const idx = user.groups.indexOf(groupId);
    if (idx > -1) {
      user.groups.splice(idx, 1);
    } else {
      user.groups.push(groupId);
    }
    this.blockUI.start();
    this.usersService
      .update(user)
      .then(() => {
        this.blockUI.stop();
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackbar.error(error.message);
      });
  }

  private processUsers() {
    this.usersByGroup = { NOGROUP: [] };
    this.users.forEach((user: any) => {
      if (!user.groups || user.groups.length === 0) {
        this.usersByGroup['NOGROUP'].push(user);
      } else {
        user.groups.forEach((groupId: string) => {
          const groupName = this.groups.find(
            (group) => group._id === groupId,
          )?.name;

          if (!this.usersByGroup[groupName]) {
            this.usersByGroup[groupName] = [];
          }

          this.usersByGroup[groupName].push(user);
        });
      }
    });

    console.log(this.usersByGroup);
  }
}
